export enum ShowTicketType {
  General = 'general',
  FreeTicket = 'free_ticket',
  Cineville = 'cineville',
  PrepaidTicket = 'prepaid_ticket',
}
